import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Typography,
  Box,
  Dialog,
  DialogTitle,
  Button,
  DialogContent,
  TextField,
} from "@mui/material";
import {
  DataGrid,
  faIR,
  GridToolbarContainer,
  gridPaginatedVisibleSortedGridRowIdsSelector,
  useGridApiContext,
} from "@mui/x-data-grid";
import { useNavigate, useLocation } from "react-router-dom";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { toMoney } from "../../util/Utils";
import { UseSellReport } from "./UseSellReport";
// import copy from "copy-text-to-clipboard";
import { useSnackbar } from "notistack";
import copy from "copy-to-clipboard";
import PrintIcon from "@mui/icons-material/Print";
import * as XLSX from "xlsx";

const getRowsFromCurrentPage = ({ apiRef }) =>
  gridPaginatedVisibleSortedGridRowIdsSelector(apiRef);

const CustomToolbar = (props) => {
  const apiRef = useGridApiContext();
  const handleExport = (options) => apiRef.current.exportDataAsPrint(options);

  const buttonBaseProps = {
    color: "secondary",
    size: "small",
    startIcon: <PrintIcon />,
  };
  return (
    <GridToolbarContainer>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          m: 1,
        }}
      >
        <Button
          sx={{ width: "80px" }}
          size="small"
          variant="contained"
          {...buttonBaseProps}
          onClick={() =>
            handleExport({ getRowsToExport: getRowsFromCurrentPage })
          }
        >
          چاپ
        </Button>
      </Box>
    </GridToolbarContainer>
  );
};

const downloadExcel = (data) => {
  if (data) {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, "DataSheet.xlsx");
  }
};

export default function ProductListGrid(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { GetItemReportusers } = UseSellReport();
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [Users, setUsers] = useState([]);
  const [productRes, setProductRes] = useState();
  const [openUsers, setOpenUsers] = useState({ show: false, rows: [] });
  const [pageState, setPageState] = useState({
    page: 1,
  });
  useEffect(() => {
    if (props.productRes) {
      setProductRes(props.productRes);
    } else {
      setProductRes();
    }
  }, [props.productRes]);

  const [filt, setFilt] = useState([]);

  const [searchSubGroup, setSearchSubGroup] = useState(
    location.state && location.state.searchSubGroup
      ? location.state.searchSubGroup
      : ""
  );

  const columns = [
    {
      field: "id",
      width: 90,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "productID",
      headerName: "کد محصول",
      width: 90,
      headerAlign: "center",
    },
    {
      field: "productName",
      headerName: "نام محصول",
      width: 350,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.productName}
          </Typography>
        );
      },
    },
    {
      field: "totalCost",
      headerName: "جمع کل",
      width: 120,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {toMoney(cellValues.row.totalCost)}
          </Typography>
        );
      },
    },

    {
      field: "جزئیات",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "جزئیات",
      renderCell: (cellValues) => {
        return (
          <Button
            onClick={() => {
              props.callbackProduct(cellValues.row.productID);
            }}
            color="secondary"
            variant="contained"
          >
            نمایش
          </Button>
        );
      },
    },
    {
      field: "کاربران",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "کاربران",
      renderCell: (cellValues) => {
        return (
          <Button
            onClick={() => {
              setProgress(true);
              let model = {
                productID: cellValues.row.productID,
                CategoryID: 0,
                BrandID: 0,
                GroupID: 0,
                date1: props.state.date1,
                date2: props.state.date2,
              };
              GetItemReportusers(model, (users) => {
                // copy(users);
                setUsers(users);
                let newModel = [];
                users.map((number, i) => {
                  newModel.push({ id: i, mobile: number });
                });
                setOpenUsers({ show: true, rows: newModel });
              });
            }}
            color="secondary"
            variant="contained"
          >
            نمایش
          </Button>
        );
      },
    },
  ];

  const columns2 = [
    {
      field: "id",
      width: 90,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "mobile",
      headerName: "موبایل",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <TextField
            placeholder="جستجو"
            size="small"
            variant="outlined"
            value={searchSubGroup}
            inputProps={{ "aria-label": "search" }}
            onChange={(evt) => {
              setSearchSubGroup(evt.target.value);
            }}
          />
        );
      },
    },
  ];

  const printProducts = () => {
    downloadExcel(productRes.products);
  };

  useEffect(() => {
    setFilt([
      {
        columnField: "mobile",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  return (
    <Box sx={{ height: "45rem" }}>
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        maxWidth="sm"
        fullWidth
        open={openUsers.show}
        onClose={() => setOpenUsers({ ...openUsers, show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box sx={{ height: "25rem" }}>
            <DataGrid
              filterModel={{
                items: filt,
              }}
              className="ltr-grid"
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns2}
              rows={openUsers.rows}
              pageSize={10}
              page={pageState.page - 1}
              Pagination
              onPageChange={(newPage) => {
                setPageState((old) => ({ ...pageState, page: newPage + 1 }));
              }}
              rowCount={openUsers.rows ? openUsers.rows.length : 1}
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: {
                  nofab: true,
                  // noPage: true,
                  rowCount: openUsers.rows ? openUsers.rows.length : "",
                },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: "id",
                      sort: "asc",
                    },
                  ],
                },
              }}
            />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Button
              color="secondary"
              sx={{ mr: 2 }}
              variant="contained"
              onClick={() => {
                // navigator.clipboard.writeText(Users);
                copy(Users);
                if (copy(Users)) {
                  setOpenUsers({ ...openUsers, show: false });
                  enqueueSnackbar("شماره ها در کلیپ بورد شما کپی شد ", {
                    variant: "info",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                }
              }}
            >
              کپی
            </Button>
            <Button
              onClick={() => setOpenUsers({ ...openUsers, show: false })}
              color="secondary"
              variant="outlined"
            >
              بستن
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      {productRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={productRes.pageCondition.pageCount}
          rows={productRes.products}
          paginationMode="server"
          page={productRes.pageCondition.page - 1}
          onPageChange={(page) => {
            props.setPage(page + 1);
          }}
          rowCount={
            productRes?.pageCondition.totalItemCount
              ? productRes.pageCondition.totalItemCount
              : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
            // Toolbar: CustomToolbar,
          }}
          componentsProps={{
            pagination: {
              isLtr: true,
              // callBack: callBack,
              printProducts: printProducts,

              nofab: true,
              print: true,
              rowCount: productRes?.pageCondition.totalItemCount
                ? productRes.pageCondition.totalItemCount
                : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: "id",
                  sort: "asc",
                },
              ],
            },
          }}
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Box>
  );
}
